/**
 * Labstep
 *
 * @module prosemirror/nodes/date
 * @desc Date node
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

const key = 'date';

export const NodeDate: LabstepNode = {
  key,
  spec: {
    attrs: {
      date: { default: new Date().toISOString().split('T')[0] }, // YYYY-MM-DD format
    },
    group: 'block',
    marks: '',
    parseDOM: [
      {
        tag: 'div',
        getAttrs: (dom: HTMLElement) => {
          const dateAttr = dom.getAttribute(`data-date`);
          if (!dateAttr) {
            return false;
          }
          return {
            date: dateAttr,
          };
        },
      },
    ],
    toDOM(node: ProseMirrorNode) {
      const { date } = node.attrs;
      return [
        'div',
        {
          'data-date': date,
        },
      ];
    },
  },
};
